<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-globe" :label="!isSmallerScreen ? 'English' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <lessons-rating-english />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-globe" :label="!isSmallerScreen ? 'Danish' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <lessons-rating-danish />
      </div>
    </vs-tab>
    
  </vs-tabs>
</template>

<script>

import LessonsRatingEnglish from "./LessonsRatingEnglish.vue"
import LessonsRatingDanish from "./LessonsRatingDanish.vue"

export default {
  components: {
    LessonsRatingEnglish,
    LessonsRatingDanish,
  },
  data() {
    return {

    }
  },
  methods: {
    
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  created() {
    
  },
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
